<script>
import moment from 'moment'
import { eventTypeDisplayNames } from './EventTypes'
import ValueComboBox from '../campaigns/ValueComboBox'

export default {
  name: 'MobilizeV2EventsFilter',
  components: {
    ValueComboBox
  },
  props: {
    value: { type: Object, required: false }
  },
  computed: {
    eventTypes() {
      return Object.entries(eventTypeDisplayNames).map(([value, text]) => ({ text, value }))
    },
    virtualOptions() {
      return ['All', 'Yes', 'No']
    },
    filters() {
      const filters = []

      if (this.form.data.city) {
        filters.push({ key: 'location.locality', comparator: '==', value: this.form.data.city })
      }
      if (this.form.data.state) {
        filters.push({ key: 'location.region', comparator: '==', value: this.form.data.state })
      }
      if (this.form.data.eventTypes.length > 0) {
        filters.push({ key: 'event_type', comparator: 'in', value: this.form.data.eventTypes })
      }
      if (this.form.data.title) {
        filters.push({ key: 'title', comparator: '==', value: this.form.data.title })
      }
      if (this.form.data.sponsorOrg) {
        filters.push({ key: 'sponsor.name', comparator: '==', value: this.form.data.sponsorOrg })
      }
      if (this.form.data.date) {
        filters.push({
          key: 'start_date',
          comparator: '>=',
          value: new Date(`${this.form.data.date} GMT-0800`).getTime() / 1000
        })
      }
      if (this.form.data.virtual && this.form.data.virtual !== 'All') {
        filters.push({ key: 'is_virtual', comparator: '==', value: this.form.data.virtual === 'Yes' })
      }

      return filters
    }
  },
  data() {
    const defaultFormData = {
      title: null,
      eventTypes: [],
      city: null,
      state: null,
      date: moment().format('YYYY-MM-DD'),
      sponsorOrg: null,
      virtual: 'All'
    }
    return {
      showDatePicker: false,
      form: {
        data: this.$props.value || defaultFormData
      }
    }
  },
  methods: {
    moment,
    removeEventType(eventType) {
      this.form.data.eventTypes.splice(this.form.data.eventTypes.indexOf(eventType), 1)
      this.form.data.eventTypes = [...this.form.data.eventTypes]
    },
    onApplyFiltersClick() {
      this.$emit('input', this.form.data)
      this.$emit('apply-filter', this.filters)
    }
  },
  watch: {
    value: function(oldValue, newValue) {
      this.form.data = newValue
      this.$emit('apply-filter', this.filters)
    }
  }
}
</script>

<template>
  <div class="mobilizev2-view">
    <div class="header-wrapper">
      <h2>Filter Events</h2>
      <v-btn color="primary" class="close-filter mini-hidden" @click="$emit('close-filter')">
        <v-icon left>close</v-icon>
        Cancel
      </v-btn>
    </div>
    <v-form class="form">
      <v-select attach label="Virtual" :items="virtualOptions" v-model="form.data.virtual" prepend-icon="mdi-laptop" />
      <v-text-field label="Title" placeholder="Title" v-model="form.data.title" prepend-icon="mdi-text" />
      <v-text-field label="City" placeholder="City" v-model="form.data.city" prepend-icon="mdi-map-marker" />
      <v-text-field label="State" placeholder="State" v-model="form.data.state" prepend-icon="mdi-map-marker" />
      <v-text-field
        label="Sponsor Org Name"
        placeholder="Sponsor Org Name"
        v-model="form.data.sponsorOrg"
        prepend-icon="mdi-text"
      />
      <value-combo-box
        v-model="form.data.eventTypes"
        :items="eventTypes"
        chips
        clearable
        label="Event Type"
        multiple
        prepend-icon="mdi-text"
        attach
      >
        <template v-slot:selection="{ attrs, item, select, selected }">
          <v-chip v-bind="attrs" :input-value="selected" close @click="select" @click:close="removeEventType(item)">
            {{ item.text }}&nbsp;
          </v-chip>
        </template>
      </value-combo-box>
      <v-text-field
        label="Start date"
        hint="YYYY-MM-DD"
        persistent-hint
        v-model="form.data.date"
        prepend-icon="mdi-calendar"
        @click="showDatePicker = true"
      />
      <v-date-picker
        class="date-picker"
        v-model="form.data.date"
        :min="moment().format('YYYY-MM-DD')"
        v-if="showDatePicker"
      />
      <div class="bottom-button-wrapper">
        <v-btn color="primary" class="apply-filter mini-hidden" @click="onApplyFiltersClick">
          <v-icon left>filter_list</v-icon>
          Apply filters
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<style lang="scss" scoped>
.mobilizev2-view {
  background: white;
  margin-top: 70px;
  min-height: 120vh;
  height: auto;
  width: calc(100vw - 250px);
}

.header-wrapper {
  display: flex;
  justify-content: space-between;

  h2 {
    margin-bottom: 20px;
  }
}

.date-picker {
  position: absolute;
  z-index: 1;
  margin-top: 20px;
}

.bottom-button-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>
